$(() => {
    $("#app-container").append(`<div class="panel-group" id="experiencedata" style="display: none;">
                <button class="hide-btn"> << </button>
                <button class="show-btn" style="display: none;"> >> </button>
                <div id="behaviour-data">
                    <h3>Pattern Card match percentages</h3>
                    <div id="behaviour-data-content"></div>
                </div>
            </div>`);

    window.registerExperienceDataButtons = function () {
        $("#experiencedata .hide-btn").click(function () {
            $("#experiencedata").css({ left: '-249px' });
            $("#experiencedata .hide-btn").hide();
            $("#experiencedata .show-btn").show();
        });

        $("#experiencedata .show-btn").click(function () {
            $("#experiencedata").css({ left: '0px' });
            $("#experiencedata .hide-btn").show();
            $("#experiencedata .show-btn").hide();
        });
    }

    window.showExperienceData = function (show = false) {
        if (show == true) {
            window.sessionStorage.setItem('showExperienceData', 'true');
            $("#experiencedata").show();
            window.registerExperienceDataButtons();
        } else {
            window.sessionStorage.removeItem('showExperienceData');
            $("#experiencedata .hide-btn").unbind("click");
            $("#experiencedata .show-btn").unbind("click");
            $("#experiencedata").hide();
        }
        requestTrackingData();
    }

    if (window.sessionStorage.getItem('showExperienceData') == 'true') {
        $("#experiencedata").show();

        window.registerExperienceDataButtons();
        requestTrackingData();
    }

    function requestTrackingData() {
        var xhttp = new XMLHttpRequest();
        var xhttpRequestCounter = 0;

        var trackingDataApiPath = {
            behaviourdata: "/rslsitecoreapi/trackingdata/getbehaviourdata"
        }

        xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                var response = JSON.parse(this.responseText);
                document.getElementById("behaviour-data-content").innerHTML = "<h3>Current Mathches</h3>";
                renderMatches(response.CurrentPatternMatches);
                //document.getElementById("behaviour-data-content").innerHTML += "<h3>Historic Mathches</h3>";
                //renderMatches(response.HistoricPatternMatches);
            }
        };
        try {
            xhttp.open("GET", trackingDataApiPath.behaviourdata, false);
            xhttp.send();
        } catch (e) {
            console.log("failed to send request to: " + trackingDataApiPath.behaviourdata);
        }
    }

    function renderActiveMatchedCards(activeCards) {
        if (activeCards == null || typeof activeCards == 'undefined') return;

        document.getElementById("behaviour-data-content").innerHTML += "<h2> Active Cards:</h2>";
        Object.values(activeCards).forEach(activeCard => {
            document.getElementById("behaviour-data-content").innerHTML += "<p><b>" + activeCard.Key + " (" + activeCard.Value + ")</b></p>";
        });
    }

    function renderMatches(matches) {
        Object.values(matches).forEach(currentMatch => {
            document.getElementById("behaviour-data-content").innerHTML += "<h4> Profile: " + currentMatch.Name + "</h4>";

            renderActiveMatchedCards(currentMatch.ActiveCard);

            document.getElementById("behaviour-data-content").innerHTML += "<h2> Match percentages:</h2>";
            Object.values(currentMatch.PatternMatches).forEach(patternMatch => {
                document.getElementById("behaviour-data-content").innerHTML += "<p>" + patternMatch.PatternName + " (%" + Math.round(patternMatch.MatchPercentage * 100) + ")</p>";
            });
        });
    }
});
